document.addEventListener('DOMContentLoaded', function () {
  const providerEl = document.getElementById('providerName');
  const AccuntNumber = document.getElementById('accountNumber');
  if (providerEl) {
    const activeProvider = providerEl.innerHTML;
    document.getElementById('cartProviderName').value = activeProvider;
    if (AccuntNumber) {
      const activeAccuntNumber = AccuntNumber.innerHTML
      document.getElementById('cartProviderAccountNumber').value = activeAccuntNumber;
    }
    document.querySelectorAll(`.account_number_li[data-name="${activeProvider}"]`).forEach(function (accountNumber, index) {
      accountNumber.classList.remove('hidden');
      if (index === 0) {
        accountNumber.click();
      }
    });
  }
  const providerNameElement = document.getElementById('providerName');
  if (providerNameElement) {
    providerNameElement.addEventListener("click", function (e) {
      const providerDropdown = document.getElementById('providerDropdown');
      if (providerDropdown.classList.contains('hidden')) {
        providerDropdown.classList.remove('hidden');
      } else {
        providerDropdown.classList.add('hidden');
      }
    });
  }
  const providerLi = document.querySelectorAll(".provider_li");
  providerLi.forEach(function (provider) {
    provider.addEventListener('click', function () {
      document.getElementById('accountNumberDropdown').classList.add('hidden');
      document.querySelectorAll(`.account_number_li`).forEach(function (accountNumber) {
        accountNumber.classList.add('hidden');
      });
      const providerName = provider.getAttribute('data-name');
      document.getElementById('providerName').innerHTML = providerName;
      document.getElementById('cartProviderName').value = providerName;
      document.getElementById('providerDropdown').classList.add('hidden');
      document.querySelectorAll(`.account_number_li[data-name="${providerName}"]`).forEach(function (accountNumber, index) {
        if (index === 0) {
          accountNumber.click();
        }
        accountNumber.classList.remove('hidden');
      });
    });
  });

  const accountNumberElement = document.getElementById('accountNumber');
  if (accountNumberElement) {
    accountNumberElement.addEventListener("click", function (e) {
      const accountNumberDropdown = document.getElementById('accountNumberDropdown');
      if (accountNumberDropdown.classList.contains('hidden')) {
        accountNumberDropdown.classList.remove('hidden');
      } else {
        accountNumberDropdown.classList.add('hidden');
      }
    });
  }
  const accountNumberLi = document.querySelectorAll(".account_number_li");
  accountNumberLi.forEach(function (accountNumber) {
    accountNumber.addEventListener('click', function () {
      const accountNumberProviderName = accountNumber.getAttribute('data-number');
      accountNumberElement.innerHTML = accountNumberProviderName;
      document.getElementById('cartProviderAccountNumber').value = accountNumberProviderName;
      document.getElementById('accountNumberDropdown').classList.add('hidden');
    });
  });
});

//===========================  Collection Tabs and Swiper Slider start =========================== //

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('[id^="collection-"]').forEach(function (sectionEl) {

    const tabs = sectionEl.querySelectorAll("ul.block__product-tab-nav li");
    const tabContents = sectionEl.querySelectorAll(".block__product-tab-slider");

    tabs.forEach(function (tab) {
      tab.addEventListener("click", function () {
        // Remove "current" from all tabs in this section
        tabs.forEach((t) => t.classList.remove("current"));
        tabContents.forEach((content) => content.classList.remove("current"));

        // Add "current" to clicked tab & relevant content
        const tabId = tab.getAttribute("data-tab");
        tab.classList.add("current");
        sectionEl.querySelector(`#${tabId}`).classList.add("current");
      });
    });

    // Init Swiper for each slider in this section
    sectionEl.querySelectorAll(".block__tab-menu-collection-slider").forEach((slider) => {
      const slideCount = slider.querySelectorAll(".swiper-slide").length;
      const isMobile = window.innerWidth < 750;
      const gridRows = isMobile
        ? (slideCount <= 2 ? 1 : 2)
        : 1;
      new Swiper(slider, {
        slidesPerView: 4,
        spaceBetween: 16,
        navigation: {
          nextEl: ".block__next-arrow",
          prevEl: ".block__prev-arrow",
        },
        breakpoints: {
          200: { slidesPerView: 2, spaceBetween: 10, grid: { rows: gridRows, } },
          499: { slidesPerView: 2, spaceBetween: 16, grid: { rows: gridRows, } },
          750: { slidesPerView: 2, spaceBetween: 16 },
          990: { slidesPerView: 3, spaceBetween: 16 },
          1199: { slidesPerView: 4, spaceBetween: 16 },
        },
      });
    });
  });
});
//===========================  Collection Tabs and Swiper Slider end =========================== //

// Download File and Show File Size in PDP

// document.addEventListener("DOMContentLoaded", function () {
//   const rows = document.querySelectorAll('#file-documents-table tbody tr');

//   rows.forEach(row => {
//     const url = row.dataset.fileUrl;

//     fetch(url, { method: 'HEAD' })
//       .then(response => {
//         const size = response.headers.get('Content-Length');
//         const sizeInKB = size ? (size / 1024).toFixed(0) : '–';
//         const filename = url.split('/').pop().split('?')[0];

//         row.querySelector('.file-download').innerHTML = `
//           ${sizeInKB} KB 
//           <a href="${url}" target="_blank" download="${filename}">{{ 'download.svg' | inline_asset_content }}</a>
//         `;
//       })
//       .catch(() => {
//         row.querySelector('.file-download').textContent = 'Unavailable';
//       });
//   });
// });


// ==========================  Product Subscription start =========================== //

document.addEventListener("change", function (event) {
  if (event.target.matches(".block_subscription-options input[type=radio]")) {
    const radio = event.target;
    const wrapper = radio.closest(".product__info-wrapper");
    const drawer = wrapper.querySelector(".block_product-subscribe_drawer");
    if (radio.checked && radio.value === "subscribe") {
      drawer && drawer.classList.add("show-subscription");
      let handleSelectChange = function () {
        const selectedValue = select.value;
        subscriptionVal && (subscriptionVal.value = selectedValue);
        // if (selectedValue != '') {
        //   select.closest('.block_product-subscribe_multiple').classList.remove('show-subscription');
        //   drawer && drawer.classList.remove('show-subscription');
        // }
      };
      const select = radio.closest(".product__info-wrapper").querySelector(".block_product-subscribe_drawer select"),
        getInputVal = select ? select.value : null,
        subscriptionVal = radio.closest(".product__info-wrapper").querySelector(".block__product-form-input-selling-plan");
      subscriptionVal && (subscriptionVal.value = getInputVal), select.removeEventListener("change", handleSelectChange), select.addEventListener("change", handleSelectChange)
    } else {
      drawer && drawer.classList.remove("show-subscription");
      const getInputVal = radio.value,
        subscriptionVal = radio.closest(".product__info-wrapper").querySelector(".block__product-form-input-selling-plan");
      subscriptionVal && (subscriptionVal.value = getInputVal)
    }
  }
});


// function getSelectedPriceAndQuantity(container) {
//   const checkedRadio = container.querySelector('.shopify_subscriptions_app_block_label input[type=radio]:checked');
//   const quantityInput = container.querySelector('.quantity__input');

//   if (!checkedRadio || !quantityInput) return null;

//   const priceElement = checkedRadio.closest('.shopify_subscriptions_app_block_label').querySelector('.block_product-grid_subscribe-price');
//   if (!priceElement) return null;

//   const rawPrice = priceElement.getAttribute('data-price') || '0';
//   const unitPrice = parseFloat(rawPrice.replace(/[^0-9.]/g, ''));
//   const quantity = parseInt(quantityInput.value, 10);

//   if (isNaN(unitPrice) || isNaN(quantity)) return null;

//   const total = unitPrice * quantity;
//   const formattedPrice = window?.Shopify?.formatMoney
//     ? Shopify.formatMoney(total * 100)
//     : `$${total.toFixed(2)}`;

//   return {
//     formattedPrice,
//     priceElement,
//     rawPrice,
//   };
// }

function getUnitPrice(container) {
  // 1. Check for active subscription price
  const checkedRadio = container.querySelector('.shopify_subscriptions_app_block_label input[type=radio]:checked');
  if (checkedRadio) {
    const priceElement = checkedRadio.closest('.shopify_subscriptions_app_block_label')?.querySelector('.block_product-grid_subscribe-price');
    if (priceElement) {
      const rawPrice = priceElement.getAttribute('data-price') || '0';
      const price = parseFloat(rawPrice.replace(/[^0-9.]/g, '')) || 0;
      if (price) return price;
    }
  }

  // 2. Fallback: regular product price element
  const priceElement = container.querySelector('.price__regular .price-item--regular');
  if (priceElement) {
    const rawPrice = priceElement.textContent || '0';
    return parseFloat(rawPrice.replace(/[^0-9.]/g, '')) || 0;
  }

  return 0;
}

function updateDisplayPrices(container) {
  const addToCartSpan = container.querySelector('.product-form__submit .add-to-cart-price');
  if (!addToCartSpan) return;

  const unitPrice = getUnitPrice(container);
  if (!unitPrice) return;

  const formattedUnitPrice = window?.Shopify?.formatMoney
    ? Shopify.formatMoney(unitPrice * 100)
    : `$${unitPrice.toFixed(2)}`;

  const quantityInput = container.querySelector('.quantity__input');
  const submitButton = container.querySelector('.product-form__submit');
  const isOOS = !quantityInput || (submitButton && submitButton.hasAttribute('disabled'));

  if (isOOS) {
    // Out-of-stock variant — show Sold Out label with correct price
    const soldOutLabel = window.variantStrings?.soldOut || 'Sold Out';
    addToCartSpan.textContent = `${soldOutLabel} - ${formattedUnitPrice}`;
  } else {
    // In-stock variant — price x quantity
    const quantity = parseInt(quantityInput.value, 10) || 1;
    const total = unitPrice * quantity;
    const formattedTotal = window?.Shopify?.formatMoney
      ? Shopify.formatMoney(total * 100)
      : `$${total.toFixed(2)}`;
    addToCartSpan.textContent = `Add To Cart - ${formattedTotal}`;
  }
}

// Add to cart button price update on radio change
// document.querySelectorAll('.shopify_subscriptions_app_block_label input[type=radio]').forEach(radio => {
//   radio.addEventListener('change', function () {
//     const container = radio.closest('.product');
//     if (!container) return;
//     updateDisplayPrices(container);
//   });
// });

// Add to cart button price update on radio or quantity change
document.addEventListener('change', function (event) {
  if (event.target.matches('.shopify_subscriptions_app_block_label input[type=radio]') ||
    event.target.matches('.quantity__input')) {
    const container = event.target.closest('.product') || event.target.closest('product-info');
    if (!container) return;
    updateDisplayPrices(container);
  }
});

// Add to cart button price update on quantity change
function initQuantityListener() {
  document.querySelectorAll('.quantity__input').forEach(input => {
    input.addEventListener('change', () => {
      const container = input.closest('.product');
      if (!container) return;
      updateDisplayPrices(container);
    });
  });
}

initQuantityListener();

// ==========================  Product Subscription End =========================== //

document.querySelectorAll('header-menu [id^="Details-"]').forEach(menu => {
  const summary = menu.querySelector('summary');

  menu.addEventListener('mouseenter', () => {
    summary.setAttribute('aria-expanded', 'true');
    menu.setAttribute('open', 'open');
    if (menu.classList.contains('mega-menu')) {
      document.body.classList.add('overflow-hidden');
    }
  });

  menu.addEventListener('mouseleave', () => {
    summary.setAttribute('aria-expanded', 'false');
    menu.removeAttribute('open');
    document.body.classList.remove('overflow-hidden');
  });

  const overlay = menu.querySelector('.block__menu-overlay');
  if (overlay) {
    overlay.addEventListener('mouseenter', () => {
      summary.setAttribute('aria-expanded', 'false');
      menu.removeAttribute('open');
      document.body.classList.remove('overflow-hidden');
    });
  }
});



function filterRecipes(selectedTag) {
  const slides = document.querySelectorAll('.block__recipe-blog-item');

  slides.forEach((slide) => {
    const tags = slide.dataset.tags.toLowerCase();
    const matches = selectedTag === 'all' || tags.includes(selectedTag);

    if (matches) {
      slide.classList.add('swiper-slide');
      slide.style.display = '';
    } else {
      slide.classList.remove('swiper-slide');
      slide.style.display = 'none';
    }
  });

  if (typeof swiper !== 'undefined') {
    swiper.update();
  }
}

document.querySelectorAll('.filter-item').forEach((btn) => {
  btn.addEventListener('click', function () {
    document.querySelectorAll('.filter-item').forEach((b) => b.classList.remove('active'));
    this.classList.add('active');
  });
});

const defaultTagBtn = document.querySelector('.filter-item.active');
if (defaultTagBtn) {
  const defaultTag = defaultTagBtn.dataset.filter;
  filterRecipes(defaultTag);
}

// start account page js
document.querySelectorAll('.block_order-mange-order').forEach((openOrderTab) => {
  openOrderTab.addEventListener("click", OnClickOpenOrderTab);
});

function OnClickOpenOrderTab(event) {
  var __this = event.currentTarget;
  var customerOrderInfo = __this.closest('.block_customers-order-info');
  customerOrderInfo.classList.toggle('open');
  __this.closest('.block_customers-order-info').querySelector('.block_customers-order-info-bottom').classList.toggle('active');
  __this.closest('.block_customers-order-info-top-right').querySelector('.block_order-mange-order').classList.toggle('active');
  __this.closest('.block_customers-order-info-top-right').querySelector('.block__toggle-button')?.classList.toggle('active');
  __this.setAttribute('aria-expanded', customerOrderInfo.classList.contains('open') ? 'true' : 'false');
}

if (window.screen.width < 1100) {
  document.querySelectorAll('.block__account-menu-list').forEach((openAccountTab) => {
    openAccountTab.addEventListener("click", OnClickOpenAccountTitleTab);
  });

  function OnClickOpenAccountTitleTab(event) {
    var __this = event.currentTarget;
    __this.closest('.block__customer-account-titles').querySelector('.block__menu-list-wrapper').classList.toggle('active');
    __this.closest('.block__customer-account-titles').querySelector('.block__account-menu-list').classList.toggle('border');
  }
}

// ==========================  Blog Title & Description same Height for all post start =========================== //
function titleEqul(name) {
  var heading = document.querySelectorAll(name);
  var titleHeight = 0;
  heading.forEach((title) => {
    var matchHeight = title.clientHeight;
    if (matchHeight > titleHeight) {
      titleHeight = title.clientHeight;
    }
  });
  heading.forEach((divHeight) => {
    divHeight.style.minHeight = titleHeight + 'px';
  });
}
titleEqul('.article-card .card__heading');

// ==========================  Blog Title & Description same Height for all post End =========================== //

// ==========================  Blog Search Filter start =========================== //
// function filterApply(value, div) {
//   let title = document.querySelectorAll(".blog-post-title");
//   let searchValue = value.toLowerCase();
//   title.forEach((e) => {
//     let dataTitle = e.getAttribute("data-post-title").toLowerCase();
//     let titleParentDiv = e.closest(".filter_box");
//     if (titleParentDiv) {
//       if (dataTitle.indexOf(searchValue) > -1) {
//         titleParentDiv.classList.add("active");
//       } else {
//         titleParentDiv.classList.remove("active");
//       }
//     }
//   });
// }
// document.addEventListener("DOMContentLoaded", function () {
//   const searchInput = document.querySelector('[id^="filter-"]');
//   const clearBtn = document.querySelector('.custom-clear-button');
//   if (searchInput) {
//     // Apply search filter as the user types
//     searchInput.addEventListener("keyup", function () {
//       filterApply(this.value, this.closest(".page-width"));
//     });

//     // Listen for 'search' event (fires when user taps the cancel (X) button 
//     // searchInput.addEventListener("search", function () {
//     //   // When cleared via cancel (X), re-run the filter to reset all
//     //   filterApply("", this.closest(".page-width"));
//     // });
//   }

//   // Close icon show and hide & Reset Filter on close icon
//   if (searchInput && clearBtn) {
//     // Show/hide clear icon based on input value
//     searchInput.addEventListener('input', function () {
//       clearBtn.classList.toggle('hidden', this.value.trim() === '');
//     });

//     // Clear input and reset filter on click
//     clearBtn.addEventListener('click', function () {
//       searchInput.value = '';
//       clearBtn.classList.add('hidden');
//       filterApply('', searchInput.closest('.page-width'));
//     });
//   }
// });

document.addEventListener("DOMContentLoaded", () => {
  const input = document.querySelector('[id^="filter-"]');
  const wrapper = document.querySelector('.blog-articles');
  const clearBtn = document.querySelector('.custom-clear-button');
  const pagination = document.querySelector('.pagination-wrapper');

  if (!input || !wrapper) return;

  const originalHTML = wrapper.innerHTML;
  let controller;

  input.addEventListener("input", () => {
    const query = input.value.trim();
    clearBtn?.classList.toggle('hidden', query === '');

    if (pagination) {
      pagination.style.display = query ? 'none' : '';
    }

    if (controller) controller.abort();
    controller = new AbortController();

    if (!query) {
      wrapper.innerHTML = originalHTML;
      return;
    }

    let searchQuery = `${query}*`;

    let url = `/search?view=ajax&type=article&q=${encodeURIComponent(searchQuery)}`;

    const GLOBAL_TAGS = [
      'Featured Recipe_General',
      'All Recipe'
    ];

    const currentTags = window.currentTag || [];

    const hasGlobalTag = currentTags.some(tag =>
      GLOBAL_TAGS.includes(tag)
    );

    if (currentTags.length > 0 && !hasGlobalTag) {
      const tagQuery = currentTags
        .map(tag => `tag:${tag}`)
        .join(' AND ');

      url += `+${encodeURIComponent(tagQuery)}`;
    }

    fetch(url, { signal: controller.signal })
      .then(res => res.text())
      .then(html => {
        wrapper.innerHTML = html;
      })
      .catch(err => {
        if (err.name !== 'AbortError') console.error(err);
      });
  });

  clearBtn?.addEventListener('click', () => {
    input.value = '';
    clearBtn.classList.add('hidden');
    wrapper.innerHTML = originalHTML;

    if (pagination) {
      pagination.style.display = '';
    }
  });
});

// ==========================  Blog Search Filter End =========================== //

// ==========================  Account Address start ======================== //

$(document).on("click", ".add-address-button", function (e) {
  e.preventDefault();

  const $container = $(this).closest(".block__customer-account-overview");
  const $addForm = $container.find("#AddAddress");

  // Only open and scroll if it's hidden
  if ($addForm.hasClass("hidden")) {
    $(".block_address_form").addClass("hidden");
    $addForm.removeClass("hidden");

    // Smooth scroll into view
    $addForm[0].scrollIntoView({ behavior: "smooth" });
  }
});

$(document).on("click", ".edit-address-button", function () {
  const formId = $(this).attr("data-form-id");
  const $container = $(this).closest(".block__customer-account-overview");

  $(".block_address_form").addClass("hidden");
  $container.find("#AddAddress").addClass("hidden");
  $container.find(`#${formId}`).removeClass("hidden");

  // Optional scroll to the edit form
  document.getElementById(formId)?.scrollIntoView({ behavior: "smooth" });
});

$(document).on("click", ".block__cancel-address-button", function () {
  $(this).closest(".block__address-fields-wrapper.block_address_form").addClass("hidden");
  $(this).closest(".block__address-fields-wrapper").addClass("hidden");
});

// ==========================  Account Address end ======================== //

// ==========================  Customer Testimonials ======================= //
const trustedFamiliesSwiper = document.querySelectorAll(
  ".trusted-families-swiper"
);
trustedFamiliesSwiper && trustedFamiliesSwiper.forEach((trustedFamiliesSwiperlist) => {
  new Swiper(trustedFamiliesSwiperlist, {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: false,
    speed: 1500,
    navigation: {
      nextEl: ".block__trusted-next-btn",
      prevEl: ".block__trusted-prev-btn",
    },
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 10,
        autoHeight: true,
      },
      750: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      1200: {
        slidesPerView: 3,
        spaceBetween: 28,
      },
    },
  });
});

// Subcollection Progress bar
document.addEventListener("DOMContentLoaded", function () {
  const list = document.querySelector(".sub-collection-list");
  const progress = document.querySelector(".scroll-progress");

  list.addEventListener("scroll", () => {
    const scrollLeft = list.scrollLeft;
    const maxScroll = list.scrollWidth - list.clientWidth;
    const percentage = (scrollLeft / maxScroll) * 100;
    progress.style.width = percentage + "%";
  });
});





// ==========================  START: Add Filters Tabs for Products/Recipes ======================== //
// async function filterSearch(type) {
//   const tabsContainer = document.getElementById('SearchTabs');
//   const gridContainer = document.getElementById('ProductGridContainer');
//   const urlParams = new URLSearchParams(window.location.search);

//   tabsContainer.setAttribute('data-active-type', type);

//   let hasFilters = Array.from(urlParams.keys()).some(key => key.startsWith('filter.'));

//   if (type === 'article' && hasFilters) {
//     gridContainer.style.opacity = '0.5';

//     const cleanParams = new URLSearchParams();
//     if (urlParams.has('q')) cleanParams.set('q', urlParams.get('q'));
//     cleanParams.set('options[prefix]', 'last');

//     const cleanUrl = window.location.pathname + '?' + cleanParams.toString();

//     history.pushState(null, '', cleanUrl);

//     const sectionId = '{{ section.id }}';
//     try {
//       const response = await fetch(`${cleanUrl}&section_id=${sectionId}`);
//       const responseText = await response.text();

//       const parser = new DOMParser();
//       const doc = parser.parseFromString(responseText, 'text/html');
//       const newHtml = doc.getElementById('ProductGridContainer').innerHTML;

//       gridContainer.innerHTML = newHtml;

//       const newSidebar = doc.getElementById('main-search-filters');
//       if (newSidebar) {
//           document.getElementById('main-search-filters').innerHTML = newSidebar.innerHTML;
//       }
//     } catch (error) {
//       console.error('Search AJAX error:', error);
//     }
//     gridContainer.style.opacity = '1';
//   }

//   applyTabDisplay(type);
// }

// function applyTabDisplay(type) {
//   const items = document.querySelectorAll('.search-item-card');
//   const tabs = document.querySelectorAll('.search-tab');
//   const filterSidebar = document.getElementById('main-search-filters');
//   const facetVertical = document.querySelector('.facets-vertical');

//   tabs.forEach(tab => {
//     tab.classList.toggle('button--primary', tab.id === 'tab-' + type);
//     tab.classList.toggle('button--secondary', tab.id !== 'tab-' + type);
//   });

//   items.forEach(item => {
//     item.style.display = (type === 'all' || item.getAttribute('data-type') === type) ? 'list-item' : 'none';
//   });

//   if (filterSidebar) {
//     filterSidebar.style.display = (type === 'article') ? 'none' : 'block';

//     if (facetVertical) {
//       facetVertical.style.display = (type === 'article') ? 'block' : 'flex';
//     }
//   }
// }

// const observer = new MutationObserver(() => {
//   const activeType = document.getElementById('SearchTabs').getAttribute('data-active-type') || 'all';
//   applyTabDisplay(activeType);
// });

// window.addEventListener('DOMContentLoaded', () => {
//   const gridContainer = document.getElementById('ProductGridContainer');
//   if (gridContainer) {
//     observer.observe(gridContainer, { childList: true, subtree: true });
//   }
//   applyTabDisplay(document.getElementById('SearchTabs').getAttribute('data-active-type') || 'all');
// });
// ==========================  END: Add Filters Tabs for Products/Recipes ======================== //


// ==========================  START: Add Filters Tabs for Products/Recipes/Pages Using AJAX ======================== //
async function filterSearch(type) {
  const tabsContainer = document.getElementById('SearchTabs');
  const gridContainer = document.getElementById('ProductGridContainer');
  const sectionId = '{{ section.id }}';

  // 1. Update the tracking attribute immediately
  tabsContainer.setAttribute('data-active-type', type);

  // 2. Build the AJAX URL
  const url = new URL(window.location.href);
  url.searchParams.delete('page'); // Always reset to page 1 on tab switch

  if (type === 'all') {
    url.searchParams.delete('type');
  } else {
    url.searchParams.set('type', type);
  }

  // Clear product filters for Recipes/Pages to avoid empty results
  if (type !== 'all' && type !== 'product') {
    Array.from(url.searchParams.keys()).forEach(key => {
      if (key.startsWith('filter.')) url.searchParams.delete(key);
    });
  }

  // Update browser address bar without reload
  history.pushState({ type: type }, '', url.toString());

  // 3. Fetch new data
  gridContainer.style.opacity = '0.5';

  try {
    const response = await fetch(`${url.pathname}${url.search}&section_id=${sectionId}`);
    const responseText = await response.text();
    const parser = new DOMParser();
    const doc = parser.parseFromString(responseText, 'text/html');

    // Swap the Grid and Pagination
    const newGridContent = doc.getElementById('ProductGridContainer').innerHTML;
    gridContainer.innerHTML = newGridContent;

    // Swap the Sidebar (to update filter counts/visibility)
    const newSidebar = doc.getElementById('main-search-filters');
    const currentSidebar = document.getElementById('main-search-filters');
    if (newSidebar && currentSidebar) {
      currentSidebar.innerHTML = newSidebar.innerHTML;
    }

    // --- CRITICAL STEP: Re-apply styles after HTML injection ---
    applyTabStyles(type);

  } catch (error) {
    console.error('AJAX Error:', error);
    window.location.href = url.toString(); // Fallback
  }

  gridContainer.style.opacity = '1';
}

function applyTabStyles(type) {
  const tabs = document.querySelectorAll('.search-tab');
  const filterSidebar = document.getElementById('main-search-filters');
  const facetVertical = document.querySelector('.facets-vertical');

  // Find the button and switch classes
  tabs.forEach(tab => {
    if (tab.id === 'tab-' + type) {
      tab.classList.add('button--primary');
      tab.classList.remove('button--secondary');
    } else {
      tab.classList.add('button--secondary');
      tab.classList.remove('button--primary');
    }
  });

  // Sidebar Layout Logic
  if (filterSidebar) {
    const isProductView = (type === 'all' || type === 'product');
    filterSidebar.style.display = isProductView ? 'block' : 'none';
    if (facetVertical) {
      facetVertical.style.display = isProductView ? 'flex' : 'block';
    }
  }
}

// Handle browser Back/Forward buttons
window.addEventListener('popstate', (event) => {
  if (event.state && event.state.type) {
    filterSearch(event.state.type);
  } else {
    window.location.reload();
  }
});

// Handle the Active UI state on page load
document.addEventListener('DOMContentLoaded', () => {
  const urlParams = new URLSearchParams(window.location.search);
  const currentType = urlParams.get('type') || 'all';
  applyTabStyles(currentType);
});
function filterSearch(type) {
  const url = new URL(window.location.href);
  const params = new URLSearchParams(url.search);

  // 1. Always reset to page 1 when changing tabs
  params.delete('page');

  // 2. Set the type
  if (type === 'all') {
    params.delete('type');
  } else {
    params.set('type', type);
  }

  // 3. If switching to Recipes or Pages, REMOVE product filters
  // This prevents the "No results found" error
  if (type !== 'all' && type !== 'product') {
    const keys = Array.from(params.keys());
    keys.forEach(key => {
      if (key.startsWith('filter.')) {
        params.delete(key);
      }
    });
  }

  // 4. Force Page Refresh with new URL
  window.location.href = window.location.pathname + '?' + params.toString();
}

// ==========================  END: Add Filters Tabs for Products/Recipes/Pages Using AJAX ======================== //
